// extracted by mini-css-extract-plugin
export var arrows = "_64-6";
export var decrementer = "_64-a";
export var disabled = "_64-4";
export var error = "_64-1";
export var hiddenText = "_64-b";
export var incrementer = "_64-9";
export var input = "_64-8";
export var inputWrapper = "_64-0";
export var leadingIcon = "_64-c";
export var readonly = "_64-3";
export var regular = "_64-7";
export var small = "_64-5";
export var warning = "_64-2";